import sliceCreator from '../../index.jsx';
import {CREATE_ACTIVITY} from '../../../constants/index.jsx';
const _createActivityAction = sliceCreator('CREATE_ACTIVITY', CREATE_ACTIVITY, 'post');

const { asyncAction: createActivityAction, reducer, clearData: clearCreateActivityAction } = _createActivityAction;

export default reducer;

export {
    createActivityAction,
    clearCreateActivityAction
}